import { useQuery } from "@tanstack/react-query";
import { getKlaviyoStatus } from "../../api/bKlaviyoApi";

export const useGetKlaviyoStatus = (organisationId, enabled = true) => {
  return useQuery({
    queryKey: ["klaviyo-status", organisationId],
    queryFn: () => getKlaviyoStatus(organisationId),
    enabled: !!organisationId && enabled,
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: true,
  });
};